import React, { useState } from "react"
import { NavLink, useLocation } from "react-router-dom"
// import { FaTachometerAlt, FaUsers, FaBoxOpen, FaCog } from "react-icons/fa";
// import Dropdown from "react-bootstrap/Dropdown";
import { handleLogout } from "../../utils/utils"

const navItems = [
  {
    name: "Dashboard",
    path: "/dashboard",
    activate: ["dashboard", ""],

    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
        className='navbar-icon'
      >
        <path d='M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z'></path>
      </svg>
    ),
  },
  {
    name: "Customers",
    path: "/customers",
    activate: ["customers", "customer"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
        className='navbar-icon'
      >
        <path d='M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z'></path>
      </svg>
    ),
  },
  {
    name: "Payment Settings",
    path: "/paymentSetting",
    activate: ["paymentSetting"],
    icon: (
      <svg
        width='17'
        height='17'
        viewBox='0 0 22 22'
        fill='#000000'
        xmlns='http://www.w3.org/2000/svg'
        className='navbar-icon'
      >
        <path d='M12.0267 22H9.97333C9.63762 21.9997 9.31365 21.8764 9.06267 21.6535C8.81168 21.4305 8.65106 21.1233 8.61117 20.79L8.39208 19.0703C7.9592 18.9298 7.53806 18.7554 7.13258 18.5488L5.76308 19.613C5.49866 19.8209 5.16691 19.924 4.83124 19.9027C4.49557 19.8814 4.17952 19.7371 3.9435 19.4975L2.49975 18.0538C2.26143 17.818 2.11829 17.5027 2.09767 17.168C2.07704 16.8334 2.18036 16.5029 2.38792 16.2397L3.45217 14.8693C3.24472 14.4641 3.07029 14.0429 2.93058 13.6098L1.20725 13.3907C0.874339 13.3495 0.567917 13.1882 0.345597 12.937C0.123277 12.6859 0.000375356 12.3621 0 12.0267L0 9.97333C0 9.27942 0.51975 8.69367 1.21 8.61117L2.92967 8.39208C3.07017 7.9592 3.24457 7.53806 3.45125 7.13258L2.38792 5.76308C2.17953 5.49864 2.07616 5.16655 2.09764 4.83055C2.11913 4.49455 2.26396 4.17833 2.50433 3.94258L3.94808 2.49883C4.18397 2.2607 4.49925 2.11768 4.8338 2.09706C5.16836 2.07644 5.49881 2.17964 5.76217 2.387L7.13167 3.45217C7.53739 3.24533 7.95884 3.07092 8.39208 2.93058L8.61117 1.20725C8.69367 0.51975 9.27942 0 9.97333 0H12.0267C12.7206 0 13.3063 0.51975 13.3888 1.21L13.6079 2.92967C14.0461 3.07175 14.4677 3.24683 14.8683 3.45125L16.2378 2.387C16.5022 2.17887 16.8341 2.07565 17.1699 2.09714C17.5057 2.11862 17.8217 2.26329 18.0574 2.50342L19.5012 3.94717C19.9934 4.42475 20.0429 5.20667 19.613 5.76125L18.5488 7.13167C18.7541 7.53225 18.9292 7.95392 19.0703 8.39117L20.7937 8.61025C21.1263 8.65137 21.4325 8.81259 21.6547 9.0636C21.8768 9.31462 21.9996 9.63813 22 9.97333V12.0267C22 12.7206 21.4803 13.3063 20.79 13.3888L19.0703 13.6079C18.9298 14.0408 18.7554 14.4619 18.5488 14.8674L19.613 16.2369C19.8211 16.5013 19.9243 16.8332 19.9029 17.169C19.8814 17.5048 19.7367 17.8208 19.4966 18.0565L18.0528 19.5003C17.8171 19.7388 17.5018 19.882 17.1672 19.9026C16.8325 19.9233 16.5019 19.8198 16.2388 19.6121L14.8683 18.5478C14.4632 18.7553 14.042 18.9297 13.6088 19.0694L13.3898 20.7928C13.3488 21.1256 13.1877 21.432 12.9367 21.6543C12.6856 21.8767 12.362 21.9996 12.0267 22ZM7.08583 17.545C7.16192 17.545 7.23983 17.5642 7.3095 17.6027C7.82395 17.8891 8.36958 18.1155 8.93567 18.2774C9.02172 18.3021 9.09866 18.3515 9.15698 18.4194C9.2153 18.4873 9.25245 18.5709 9.26383 18.6597L9.5205 20.6763C9.548 20.9064 9.74692 21.0833 9.97333 21.0833H12.0267C12.1378 21.0818 12.2447 21.0403 12.3277 20.9664C12.4107 20.8925 12.4643 20.7911 12.4786 20.6809L12.7362 18.6606C12.7476 18.5718 12.7847 18.4883 12.843 18.4203C12.9013 18.3524 12.9783 18.303 13.0643 18.2783C13.6304 18.1164 14.176 17.89 14.6905 17.6037C14.769 17.5598 14.8587 17.5401 14.9484 17.5469C15.0381 17.5538 15.1237 17.5869 15.1947 17.6422L16.7988 18.8888C16.8852 18.9584 16.9942 18.9936 17.105 18.9879C17.2158 18.9821 17.3205 18.9358 17.3993 18.8577L18.8522 17.4048C18.9316 17.326 18.9793 17.2208 18.9859 17.1091C18.9925 16.9974 18.9576 16.8873 18.8879 16.7997L17.6413 15.1956C17.5861 15.1246 17.553 15.0389 17.5462 14.9493C17.5393 14.8596 17.559 14.77 17.6027 14.6914C17.8891 14.177 18.1155 13.6313 18.2774 13.0653C18.3021 12.9792 18.3515 12.9023 18.4194 12.8439C18.4873 12.7856 18.5709 12.7485 18.6597 12.7371L20.6763 12.4804C20.7875 12.4665 20.8898 12.413 20.9646 12.3296C21.0394 12.2462 21.0815 12.1386 21.0833 12.0267V9.97333C21.0818 9.8622 21.0403 9.75533 20.9664 9.67232C20.8925 9.58932 20.7911 9.53574 20.6809 9.52142L18.6606 9.26383C18.5718 9.25245 18.4883 9.2153 18.4203 9.15698C18.3524 9.09866 18.303 9.02172 18.2783 8.93567C18.1164 8.36958 17.89 7.82395 17.6037 7.3095C17.5596 7.23106 17.5397 7.14131 17.5466 7.05159C17.5534 6.96186 17.5867 6.87617 17.6422 6.80533L18.8888 5.20117C18.9586 5.1151 18.9941 5.00628 18.9886 4.89562C18.983 4.78496 18.9367 4.68027 18.8586 4.60167L17.4057 3.14875C17.3273 3.06871 17.2219 3.02072 17.1101 3.01411C16.9982 3.0075 16.8879 3.04275 16.8007 3.113L15.1965 4.35967C15.1254 4.41501 15.0396 4.44818 14.9498 4.45503C14.8599 4.46188 14.7701 4.4421 14.6914 4.39817C14.1771 4.11154 13.6314 3.88516 13.0653 3.7235C12.9792 3.6988 12.9023 3.64944 12.8439 3.58151C12.7856 3.51358 12.7485 3.43005 12.7371 3.34125L12.4804 1.32458C12.4667 1.21329 12.4132 1.1107 12.3299 1.03574C12.2465 0.96077 12.1388 0.918481 12.0267 0.916667H9.97333C9.8622 0.918166 9.75533 0.959678 9.67232 1.03359C9.58932 1.10751 9.53574 1.20887 9.52142 1.31908L9.26383 3.33942C9.25239 3.4283 9.21523 3.51191 9.15694 3.57998C9.09864 3.64805 9.02174 3.69761 8.93567 3.72258C8.36952 3.88393 7.82386 4.11001 7.3095 4.39633C7.23093 4.4404 7.14113 4.46033 7.0513 4.45365C6.96147 4.44696 6.8756 4.41395 6.80442 4.35875L5.20025 3.11208C5.11419 3.04229 5.00537 3.00678 4.89471 3.01236C4.78404 3.01795 4.67935 3.06424 4.60075 3.14233L3.14783 4.59617C3.06835 4.67487 3.02074 4.78016 3.01414 4.89182C3.00754 5.00348 3.04242 5.11365 3.11208 5.20117L4.35875 6.80533C4.41391 6.87633 4.44697 6.96198 4.45381 7.05163C4.46066 7.14127 4.44099 7.23095 4.39725 7.3095C4.1105 7.82377 3.88411 8.36944 3.72258 8.93567C3.69788 9.02172 3.64852 9.09866 3.58059 9.15698C3.51266 9.2153 3.42914 9.25245 3.34033 9.26383L1.32367 9.5205C1.21254 9.53401 1.11007 9.58733 1.03524 9.67059C0.960413 9.75385 0.918287 9.8614 0.916667 9.97333V12.0267C0.916667 12.2531 1.09358 12.452 1.31908 12.4786L3.33942 12.7362C3.42822 12.7476 3.51174 12.7847 3.57967 12.843C3.6476 12.9013 3.69697 12.9783 3.72167 13.0643C3.88667 13.6382 4.114 14.1854 4.39633 14.6905C4.44042 14.7689 4.4603 14.8587 4.45345 14.9484C4.44659 15.0381 4.41332 15.1238 4.35783 15.1947L3.11117 16.7988C3.04138 16.8849 3.00586 16.9937 3.01144 17.1044C3.01703 17.215 3.06332 17.3197 3.14142 17.3983L4.59433 18.8513C4.67293 18.9309 4.77825 18.9787 4.88997 18.9853C5.00169 18.9919 5.1119 18.9569 5.19933 18.887L6.8035 17.6403C6.88485 17.5789 6.9839 17.5455 7.08583 17.545Z' />
        <path d='M10.9993 15.5827C8.4721 15.5827 6.41602 13.5266 6.41602 10.9993C6.41602 8.4721 8.4721 6.41602 10.9993 6.41602C13.5266 6.41602 15.5827 8.4721 15.5827 10.9993C15.5827 13.5266 13.5266 15.5827 10.9993 15.5827ZM10.9993 7.33268C8.97718 7.33268 7.33268 8.97718 7.33268 10.9993C7.33268 13.0215 8.97718 14.666 10.9993 14.666C13.0215 14.666 14.666 13.0215 14.666 10.9993C14.666 8.97718 13.0215 7.33268 10.9993 7.33268Z' />
      </svg>
    ),
  },
  {
    name: "Subscriptions",
    path: "/subscriptions",
    activate: ["subscriptions"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        strokeWidth={1.5}
        stroke='#000'
        className='size-6'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z'
        />
      </svg>
    ),
  },
  {
    name: "Mobile Devices",
    path: "/devices",
    activate: ["devices"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#544040'
        viewBox='0 0 256 256'
      >
        <path d='M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM72,64H184V192H72Zm8-32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z'></path>
      </svg>
    ),
  },
  {
    name: "Locations",
    path: "/locations",
    activate: ["locations", "location"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z'></path>
      </svg>
    ),
  },
  {
    name: "Sensors",
    path: "/sensors-list",
    activate: ["sensors-list"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#544040'
        viewBox='0 0 256 256'
      >
        <path d='M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z'></path>
      </svg>
    ),
  },
  {
    name: "Police",
    path: "/law-enforcement-domain",
    activate: ["law-enforcement-domain"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M243.32,116.69l-16-16a16,16,0,0,0-20.84-1.53L156.84,49.52a16,16,0,0,0-1.52-20.84l-16-16a16,16,0,0,0-22.63,0l-64,64a16,16,0,0,0,0,22.63l16,16a16,16,0,0,0,20.83,1.52L96.69,124,31.31,189.38A25,25,0,0,0,66.63,224.7L132,159.32l7.17,7.16a16,16,0,0,0,1.52,20.84l16,16a16,16,0,0,0,22.63,0l64-64A16,16,0,0,0,243.32,116.69ZM80,104,64,88l64-64,16,16ZM55.32,213.38a9,9,0,0,1-12.69,0,9,9,0,0,1,0-12.68L108,135.32,120.69,148ZM101,105.66,145.66,61,195,110.34,150.35,155ZM168,192l-16-16,4-4h0l56-56h0l4-4,16,16Z'></path>
      </svg>
    ),
  },
  {
    name: "School",
    path: "/school-domain",
    activate: ["school-domain"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M251.76,88.94l-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V240a8,8,0,0,0,16,0V199.51a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12ZM128,200c-42.52,0-67.62-21-78.55-32.72a.16.16,0,0,1,0-.11V126.4l75.72,40.38a8,8,0,0,0,7.52,0l48.31-25.77v57.63A114,114,0,0,1,128,200Zm78.65-33.85a.15.15,0,0,1,0,.11,99.75,99.75,0,0,1-14.65,13.16V132.44l14.65-7.81ZM188,133.63a1.09,1.09,0,0,1,0-.18h0ZM128,150.6,32.43,100,128,49.4,223.57,100Z'></path>
      </svg>
    ),
  },
  {
    name: "Terms Logs",
    path: "/termsLogs",
    activate: ["termsLogs"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#000000'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='navbar-icon'
      >
        <line x1='9' y1='6' x2='20' y2='6'></line>
        <line x1='9' y1='12' x2='20' y2='12'></line>
        <line x1='9' y1='18' x2='20' y2='18'></line>
        <circle cx='4' cy='6' r='1'></circle>
        <circle cx='4' cy='12' r='1'></circle>
        <circle cx='4' cy='18' r='1'></circle>
      </svg>
    ),
  },
  {
    name: "Sensor & SOS Events",
    path: "/sensor-sos-events",
    activate: ["sensor-sos-events"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-48-56a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z'></path>
      </svg>
    ),
  },
  {
    name: "Send Notification",
    path: "/send-notification",
    activate: ["send-notification"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M224,71.1a8,8,0,0,1-10.78-3.42,94.13,94.13,0,0,0-33.46-36.91,8,8,0,1,1,8.54-13.54,111.46,111.46,0,0,1,39.12,43.09A8,8,0,0,1,224,71.1ZM35.71,72a8,8,0,0,0,7.1-4.32A94.13,94.13,0,0,1,76.27,30.77a8,8,0,1,0-8.54-13.54A111.46,111.46,0,0,0,28.61,60.32,8,8,0,0,0,35.71,72Zm186.1,103.94A16,16,0,0,1,208,200H167.2a40,40,0,0,1-78.4,0H48a16,16,0,0,1-13.79-24.06C43.22,160.39,48,138.28,48,112a80,80,0,0,1,160,0C208,138.27,212.78,160.38,221.81,175.94ZM150.62,200H105.38a24,24,0,0,0,45.24,0ZM208,184c-10.64-18.27-16-42.49-16-72a64,64,0,0,0-128,0c0,29.52-5.38,53.74-16,72Z'></path>
      </svg>
    ),
  },
  {
    name: "Contact Messages",
    path: "/contact-messages",
    activate: ["contact-messages"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z'></path>
      </svg>
    ),
  },
  {
    name: "App Version",
    path: "/app-version",
    activate: ["app-version"],
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        fill='#000000'
        viewBox='0 0 256 256'
      >
        <path d='M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z'></path>
      </svg>
    ),
  },
  // {
  //   name: "Sensor SOS Settings",
  //   path: "/sensor-sos-settings",
  //   activate: ["sensor-sos-settings"],
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"></path></svg>
  //   ),
  // },
  // { name: "Users", path: "/users", icon: <FaUsers /> },
  // { name: "Products", path: "/products", icon: <FaBoxOpen /> },
  // { name: "Settings", path: "/settings", icon: <FaCog /> },
]

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }: any) => {
  const toggleSidebar = () => setIsSidebarOpen((prev: any) => !prev)
  const [isHovered, setIsHovered] = useState(false)
  const location = useLocation()
  const renderToggleIcon = () => {
    if (isSidebarOpen) {
      return isHovered ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth={1.5}
          stroke='currentColor'
          className='sidebar-arrow-icon'
        >
          <path strokeLinecap='round' strokeLinejoin='round' d='M15.75 19.5 8.25 12l7.5-7.5' />
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth={1.5}
          stroke='currentColor'
          className='sidebar-line-icon'
        >
          <path strokeLinecap='round' strokeLinejoin='round' d='M5 12h14' />
        </svg>
      )
    } else {
      return isHovered ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth={1.5}
          stroke='currentColor'
          className='sidebar-arrow-icon'
        >
          <path strokeLinecap='round' strokeLinejoin='round' d='m8.25 4.5 7.5 7.5-7.5 7.5' />
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth={1.5}
          stroke='currentColor'
          className='sidebar-line-icon'
        >
          <path strokeLinecap='round' strokeLinejoin='round' d='M5 12h14' />
        </svg>
      )
    }
  }

  return (
    <>
      {isSidebarOpen && (
        <div className='sidebar-overlay ' onClick={() => setIsSidebarOpen(false)}></div>
      )}

      <aside className={`sidebar ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <div className='closeSidebarbtn-section'>
          <button onClick={() => setIsSidebarOpen(false)}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='icon'
            >
              <path strokeLinecap='round' strokeLinejoin='round' d='M6 18 18 6M6 6l12 12' />
            </svg>
          </button>
        </div>

        <div className='userProfile-section'>
          <button className='userProfile-section-btn'>
            <div className='userProfile-section-img'>
              <span className='badge-text'>A</span>
            </div>
            <div className={`userProfile-name-section ${isSidebarOpen ? "show" : "hide"}`}>
              <h5>Admin Panel</h5>
            </div>
          </button>
        </div>

        <div className='navbar-main-section'>
          <nav className='navbar'>
            <section className='navbar-sections'>
              <ul className=' navbar-list'>
                {navItems.map((item) => {
                  const navActive = item.activate.includes(location.pathname.split("/")[1])
                    ? isSidebarOpen
                      ? "active-open"
                      : "active-collapsed"
                    : ""

                  const active = item.activate.includes(location.pathname.split("/")[1])
                    ? "label-active"
                    : "label-inactive"
                  const iconactive = item.activate.includes(location.pathname.split("/")[1])
                    ? "icon-active"
                    : "icon-inactiv"
                  return (
                    <li key={item.name} className='navbar-item'>
                      <NavLink
                        to={item.path}
                        className={`navbar-link ${navActive}`}
                        onClick={() => {
                          if (window.innerWidth <= 1024) {
                            setIsSidebarOpen(false)
                          }
                        }}
                      >
                        <span className='flex items-center justify-center w-full max-w-[24px] min-w-[24px] h-[24px] navbar-icon-wrapper'>
                          {React.cloneElement(item.icon, {
                            className: `navbar-icon ${iconactive}`,
                          })}
                        </span>
                        <span className={`navbar-label ${active} `}>{item.name}</span>
                      </NavLink>
                    </li>
                  )
                })}
              </ul>
            </section>
          </nav>

          <div className='logoutBtn-section'>
            <button onClick={handleLogout}>
              <span>Logout</span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth={1.5}
                stroke='currentColor'
                className='size-6'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9'
                />
              </svg>
            </button>
          </div>
        </div>
      </aside>
      <div
        className={`sidebar-handle ${
          isSidebarOpen ? "sidebarToggle-open" : "sidebarToggle-closed"
        } `}
      >
        <button
          className='sidebartoggleBtn'
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={toggleSidebar}
        >
          {renderToggleIcon()}
        </button>
      </div>
    </>
  )
}

export default Sidebar
